import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { stockClassKeys } from './keys';
import { stockClassListSchema } from './responseSchemas';
import { StockClass } from './types';

// Stock-class picker source. Hits the cap-table endpoint that already lists
// classes per corporation; the response is mapped to `StockClass` shape via
// the schema transform. Create + apply-to-unassigned are atomic with
// shareholder writes (no standalone hooks needed).
export const useStockClassList = (
  corporationId: number | null | undefined,
) => {
  return useQuery({
    queryKey: stockClassKeys.FETCH_LIST(corporationId as number),
    queryFn: async () => {
      const response = await fetcher(
        `capTable/stockClass/byCorporationId/${corporationId as number}`,
        { method: 'GET' },
      );
      if (!response.ok) throw new Error('Failed to fetch stock classes');
      const json = await response.json();
      return stockClassListSchema.parse(json) as StockClass[];
    },
    enabled: corporationId != null && corporationId > 0,
  });
};
